import EvaluationStates from "../States/EvaluationStatesCircle";
import { DimensionEvaluation } from "../../interfaces/Evaluations";
import './styles.css';
import ChevronButton from "../Buttons/ChevronButton";
import { useHorizontalScroll } from "../../hooks/useHorizontalScroll";

interface TabsProps {
    tabs: DimensionEvaluation[];
    selectedIndex: number | null;
    onTabClick: (index: number, name?: string) => void;
}

const Tabs = ({ tabs, selectedIndex, onTabClick }: TabsProps) => {
    const {
        containerRef,
        hasOverflowLeft,
        hasOverflowRight,
        scroll,
        checkOverflow
    } = useHorizontalScroll([tabs]);

    return (
        <div className="relative flex items-center px-4 md:px-0">
            {hasOverflowLeft && (
                <div className="relative">
                    <ChevronButton
                        onClick={() => scroll("left")}
                        direction="left"
                        disabled={false}
                        aria_label="Scroll left"
                        buttonStyles="flex items-center justify-center relative z-[5822662] shadow-custom-dual rounded-sm"
                    />
                    <div className="end-blur-reverse top-0 left-0 w-[4rem] h-[2rem]"></div>
                </div>
            )}
            <div
                ref={containerRef}
                className="flex gap-4 md:gap-5 overflow-auto scrollbar-hide flex-grow"
                onScroll={checkOverflow}
            >
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`flex items-center gap-2 py-4 px-1 md:p-4 justify-center min-w-max last:mr-6
                            ${selectedIndex === tab.id
                                ? "border-b-4 border-brand-green-30"
                                : "hover:bg-[#EDEDED] transition-all duration-200"
                            }`}
                        onClick={() => onTabClick(tab.id, tab.nombre)}
                    >
                        <EvaluationStates
                            status={tab.trivalente_dimension}
                            size={12}
                        />
                        <span className={`text-tsmall ${selectedIndex === tab.id
                            ? "text-brand-green-30 md:text-system-light-100"
                            : "text-system-light-40"
                            }`}
                        >
                            {tab.nombre}
                        </span>
                    </button>
                ))}
            </div>
            {hasOverflowRight && (
                <div className="relative">
                    <ChevronButton
                        onClick={() => scroll("right")}
                        direction="right"
                        disabled={false}
                        aria_label="Scroll right"
                        buttonStyles="flex items-center justify-center relative z-[5822662] shadow-custom-dual rounded-sm"
                    />
                    <div className="end-blur top-0 right-0 w-[4rem] h-[2.5rem]"></div>
                </div>
            )}
        </div>
    );
};

export default Tabs;